module.exports = __webpack_public_path__ + "static/griffon-7cf451217c6389467edbc094165e7625.jpg";